import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=9b054092&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=ts&"
export * from "./layout.vue?vue&type=script&lang=ts&"
import style0 from "./layout.vue?vue&type=style&index=0&id=9b054092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b054092",
  null
  
)

export default component.exports